import React, { useState } from "react";
import { ShoppingCart, Menu, CreditCard, IndianRupee } from "lucide-react";

import Overview from "../components/Reports/Overview";
import Orders from "../components/Reports/Orders";
// import MenuReport from "../components/Reports/Menu";
import Items from "../components/Reports/Items";
import Payments from "../components/Reports/Payments";

const REPORT_TYPES = [
  {
    id: "overview",
    label: "Overview",
    icon: <IndianRupee className="w-4 h-4" />,
  },
  { id: "items", label: "Food Items", icon: <Menu className="w-4 h-4" /> },
  { id: "orders", label: "Orders", icon: <ShoppingCart className="w-4 h-4" /> },
  // { id: "staff", label: "Staff", icon: <Users className="w-4 h-4" /> },
  // { id: "menu", label: "Menu", icon: <Menu className="w-4 h-4" /> },
  {
    id: "payments",
    label: "Payments",
    icon: <CreditCard className="w-4 h-4" />,
  },
];

const ReportContent = ({ type }) => {
  switch (type) {
    case "overview":
      return <Overview />;
    case "orders":
      return <Orders />;
    // case "menu":
    //   return <MenuReport />;
    case "items":
      return <Items />;
    case "payments":
      return <Payments />;
    default:
      return <></>;
  }
};

const OverAllReports = () => {
  const [activeTab, setActiveTab] = useState(REPORT_TYPES[0].id);

  return (
    <div className="report-container h-screen flex flex-col overflow-y-auto overflow-x-hidden">
      {/* Report Tabs - Fixed at top */}
      <div className="report-tabs flex-none">
        <div className="report-tabs__list hide-scrollbar">
          {REPORT_TYPES.map((type) => (
            <button
              key={type.id}
              onClick={() => setActiveTab(type.id)}
              className="report-tabs__trigger"
              data-state={activeTab === type.id ? "active" : ""}
            >
              {type.icon} {type.label}
            </button>
          ))}
        </div>
      </div>

      {/* Scrollable Content Area */}
      <div className="pb-[120px] md:pb-[unset]">
        <ReportContent type={activeTab} />
      </div>      
    </div>
  );
};

export default OverAllReports;
